<script context="module">
    import Breadcrumb from "./Partials/Breadcrumb.svelte";
    export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
    import { useForm } from "@inertiajs/svelte";

    export let error, office;

    const form = useForm("actionsRequiredForm", {
        email: null,
    });

    let success;

    function submitForm() {
        $form.post(window.route("renewal.actions_required.submit"), {
            onSuccess: () => {
                success = true;
            },
        });
    }

    let url = office.assess_online_url || office.url || false;
</script>

<div class="row">
    <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
            <h1>Actions Required</h1>
            <Breadcrumb>
                <span slot="home"></span>
                <span slot="actions"></span>
            </Breadcrumb>
        </div>
        <p class="fs-6">
            Oops! There is a problem preventing you from renewing your tags
            online.
        </p>
    </div>

    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="alert alert-primary">
                    {error}
                </div>
                <p class="ps-3">
                    <strong>Don't panic!</strong> Just follow the steps below:
                </p>
                <div class="control-group ms-3">
                    <h3 class="fw-light mb-2">1. Enter your email address</h3>
                    <div class="ms-4">
                        <p>
                            <i
                                >We'll keep an eye on your registration and let
                                you know when it is ready so you can come back
                                and <u>pick up where you left off.</u> We'll also
                                send you a reminder next year when it is time to
                                assess.</i
                            >
                        </p>

                        <div class="input-group form-floating w-50 ms-4">
                            <input
                                type="email"
                                class="form-control focus-ring"
                                id="email"
                                placeholder="me@example.com"
                                disabled={$form.processing || success}
                                class:is-invalid={$form.errors.modal?.email ?? false}
                                style="--bs-focus-ring-width: 0px"
                                bind:value={$form.email}
                            />
                            <label for="email" class="form-label"
                                >Email Address</label
                            >
                            <button
                                class="btn btn-primary rounded-end"
                                class:btn-success={success}
                                type="button"
                                disabled={$form.processing || success}
                                on:click={submitForm}>Notify Me</button
                            >
                            {#if $form.errors.modal?.email ?? false}
                                <div class="invalid-feedback">
                                    {$form.errors.modal?.email ?? false}
                                </div>
                            {/if}
                        </div>

                        {#if success}
                            <div class="alert alert-success mt-4">
                                Success! You’re signed up to get assessment
                                alerts from ARSTAR.com and one step closer to
                                being able to renew your tags.<br /><br />Check
                                your inbox for information on how to assess in
                                your county - it’s waiting for you now. And be
                                sure to assess so you can come back and finish
                                renewing your tags before they expire.
                            </div>
                        {/if}
                    </div>
                </div>
                <div class="control-group mt-5 ms-3">
                    <h3 class="fw-light mb-3">
                        2. Contact your county assessor to assess your property
                    </h3>

                    <div class="ms-4">
                        {#if url}
                            <p>
                                In <strong>{office.county} County</strong>, you
                                can assess online at
                                <a href={url} target="_blank">{url}</a>. You may
                                need to allow 2-5 business days for your
                                assessment to process, but once it is complete
                                we'll send you an email to let you know when you
                                can complete your tag renewal.
                            </p>
                            <p>
                                You can also contact the assessor's office at <a
                                    type="tel"
                                    href="tel:{office.phone_number}"
                                    >{office.phone_number}</a
                                >.
                            </p>
                        {:else}
                            <p>
                                Online assessment isn't yet available in <strong
                                    >{office.county} County</strong
                                >, but you can contact the assessor's office by
                                calling
                                <a type="tel" href="tel:{office.phone_number}"
                                    >{office.phone_number}</a
                                >. Once your assessment has been processed,
                                we'll send you an email to let you know when you
                                can complete your tag renewal.
                            </p>
                        {/if}

                        <p>
                            If you've recently moved to a new county, please
                            click <a
                                href="http://www.ar.gov/counties"
                                target="_blank">here</a
                            > to find your new county assessor information.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
